/**
 * Share Popup
 * @function sharePopup
 * @param {url} url 
 */

const sharePopup = (url) => {
    let width = 600;
    let height = 400;
    let leftPosition = 0;
    let topPosition = 0;

    leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
    topPosition = (window.screen.height / 2) - ((height / 2) + 50);

    let windowFeatures = 'status=no, height=' + height + ', width=' + width +
        ', resizable=yes, left=' + leftPosition + ', top=' + topPosition +
        ', screenX=' + leftPosition + ', screenY=' + topPosition +
        ', toolbar=no, menubar=no, scrollbars=no, location=no, directories=no';
    window.open(url, 'Social Share', windowFeatures);
};

export default sharePopup;